import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SettingsProvider from "../../../../../src/utils/SettingsProvider";
import { ToastContainer } from "react-toastify";
import ToastCloseButton from "../../../../../src/utils/ToastCloseButton";
import GlobalNav from "../../../../../src/components/GlobalNav/GlobalNav";
import Footer from "../../../../../src/components/Footer/Footer";
import SkipLink from "../../../../../src/components/SkipLink/SkipLink";
import ClassroomSecondaryNav from "../SecondaryNav/ClassroomSecondaryNav";
import { ClassroomAppRoutes } from "../AppRoutes/ClassroomAppRoutes";

export const ClassroomAppContent = ({ isEmbedded }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const location = useLocation();
  const isSelectUserTypePage = location.pathname === `/${locale}/login`;
  const isJoinPage = new RegExp(`^/${locale}/join(/|$)`).test(
    location.pathname,
  );

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <SettingsProvider id="app" className="app--classroom">
      <SkipLink />
      <ToastContainer
        enableMultiContainer
        containerId="top-center"
        position="top-center"
        className="toast--top-center"
        closeButton={ToastCloseButton}
      />

      {!isEmbedded && !isSelectUserTypePage && !isJoinPage && (
        <>
          <GlobalNav redirectToLogin />
          <ClassroomSecondaryNav />
        </>
      )}

      <ClassroomAppRoutes />
      {!isJoinPage && <Footer />}

      <ToastContainer
        enableMultiContainer
        containerId="bottom-center"
        position="bottom-center"
        className="toast--bottom-center"
      />
    </SettingsProvider>
  );
};
